/**
 * Server-side backdate cap rejections (fallback path).
 *
 * The client normally blocks an out-of-window date first (`useBackdateGuard`),
 * but the database is the real boundary: the backdate triggers / RPCs
 * (`log_job`, job-date trigger, `shift_no_service`, `edit_shifted_date`,
 * `reschedule_visit`, `edit_reschedule_date`, no-service create) raise SQLSTATE
 * 22023 with an English message containing "too far back", e.g.
 * "job date too far back for admin (lifecycle=active): minimum allowed is
 * 2026-08-30" (also prefixed "no-service", "shift_no_service:", ...).
 *
 * Callers that hit one of these show ONE localized message instead of raw SQL
 * text or a generic failure toast.
 *
 * Some call sites re-wrap the PostgREST error (`new Error(error.message)`),
 * which drops `.code` — so a missing code is accepted as long as the message
 * matches; a DIFFERENT code never is.
 */
const BACKDATE_SQLSTATE = '22023';
const BACKDATE_MESSAGE_RE = /too far back/i;

export function isBackdateServerError(err) {
  if (!err || typeof err === 'string') {
    return typeof err === 'string' && BACKDATE_MESSAGE_RE.test(err);
  }
  const message = typeof err.message === 'string' ? err.message : '';
  if (!BACKDATE_MESSAGE_RE.test(message)) return false;
  return err.code == null || err.code === BACKDATE_SQLSTATE;
}

export function getBackdateServerErrorMessage(intl) {
  return intl.formatMessage({
    id: 'errors.backdate.outsideWindow',
    defaultMessage:
      "That date is outside the window you're allowed to log or change. Pick a more recent date.",
  });
}
